import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { broadcastScheduleQueryKeys } from './query-keys';

export type TDeleteProgramBroadcastParams = {
  id: string;
};

export function deleteProgramBroadcast({ id }: TDeleteProgramBroadcastParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/program_broadcasts/${id}`);
}

type MutationFn = typeof deleteProgramBroadcast;

type TUseDeleteProgramBroadcastParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteProgramBroadcast({ config }: TUseDeleteProgramBroadcastParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();
  const { t } = useTranslation();

  return useMutation({
    ...config,
    mutationFn: deleteProgramBroadcast,
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification(t('La emisión no existe'));
      }
      addErrorNotification(t('No se ha podido eliminar la emisión seleccionada'));
    },
    onSuccess(data, variables, context) {
      config?.onSuccess?.(data, variables, context);
      addSuccessNotification(t('Se ha eliminado la emisión'), t('El proceso ha sido un éxito'));
      queryClient.invalidateQueries({ queryKey: broadcastScheduleQueryKeys.all });
    },
  });
}
